export const certificateIssuanceReport = "CERTIFICATE_ISSUANCE_REPORT";
export const attendanceReport = "ATTENDANCE_REPORT";
export const certificatePendingReport = "CERTIFICATE_PENDING_REPORT";
export const courseEnrollmentReport = "COURSE_ENROLLMENT_REPORT";
export const instructorDailyAttendanceReport = "INSTRUCTOR_DAILY_ATTENDANCE_REPORT";
export const instructorDashboardSummary = "INSTRUCTOR_DASHBOARD_SUMMARY";
export const instructorAssessmentReport = "INSTRUCTOR_ASSESSMENT_REPORT";
export const instructorAssessmentReportDetails =
  "INSTRUCTOR_ASSESSMENT_REPORT_DETAILS";
